import { Badge } from "@/components/ui/badge";
import { severityLabel } from "./severityLabel";

/** Coloured badge: red = error, amber = warning, slate = transient. */
export function SeverityBadge({ severity }: { severity: string }) {
  const cls =
    severity === "error"
      ? "border-red-200 bg-red-100 text-red-800"
      : severity === "warning"
        ? "border-amber-200 bg-amber-100 text-amber-900"
        : "border-slate-200 bg-slate-100 text-slate-700";
  return (
    <Badge variant="outline" className={cls}>
      {severityLabel(severity)}
    </Badge>
  );
}
